"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _scss = require("@scss");

var _icons = _interopRequireDefault(require("~icons"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["name", "as", "size", "color", "classes"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(_ref) {
  var _json$name, _json$name$ReactCompo, _json$name2;

  var name = _ref.name,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'svg' : _ref$as,
      size = _ref.size,
      color = _ref.color,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? {} : _ref$classes,
      props = _objectWithoutProperties(_ref, _excluded);

  var Component = as === 'image' ? (_json$name = _icons["default"][name]) === null || _json$name === void 0 ? void 0 : _json$name['default'] : (_json$name$ReactCompo = (_json$name2 = _icons["default"][name]) === null || _json$name2 === void 0 ? void 0 : _json$name2['ReactComponent']) !== null && _json$name$ReactCompo !== void 0 ? _json$name$ReactCompo : null;

  if (Component === null) {
    console.error("".concat(name, " icon doesn't exist"));
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, typeof Component === 'string' ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/alt-text
  _react["default"].createElement("img", _extends({
    src: Component,
    className: (0, _scss.cls)(_stylesModule["default"].icon, classes.icon)
  }, size && {
    'data-size': size
  }, props)) : /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _scss.cls)(_stylesModule["default"].icon, classes.icon),
    color: color,
    "data-size": size
  }, size && {
    'data-size': size
  }, props)));
};

var _default = Icon;
exports["default"] = _default;